module.exports = {
    wifiRssi: "WiFi Signal",
    gsmRssi: "GSM Signal",
    meterType: "Angeschlossener Stromzähler",
    conType: "Verbindungstyp",
    temperature: "Temperatur",
    humidity: "Feuchtigkeit",
    co2: "CO2",
    lux1: "Umgebungslicht",
    lux2: "Umgebungslicht 2",
    motion_sensor: "PIR Bewegung",
    import: "Sammlung",
    export: "Versorgung",
    phase: "Phase",
    quadrant: "Quadrant",
    cumulative: "Kumulativ",
    average: "Durchschnitt",
    voltage_profile: "Spannungsprofil",
    voltage: "Spannung",
    average_voltage: "Durchschnittliche Spannung",
    current_profile: "Aktuelles Profil",
    current: "Strom",
    cumulative_current: "Summenstrom",
    active_power_profile: "Wirkleistungsprofil",
    active_power: "Wirkleistung",
    active_energy: "Wirkenergie",
    total_energy: "Gesamtenergie",
    cumulative_active_power: "Kumulative Wirkleistung",
    reactive_power_profile: "Blindleistungsprofil",
    reactive_power: "Blindleistung",
    cumulative_reactive_power: "Kumulative Blindleistung",
    apparent_power_profile: "Scheinleistungsprofil",
    energy_import: "Energieverbrauch",
    energy_export: "Energieversorgung",
    energy_day: "Täglicher Energieverbrauch",
    realtime_voltage: "Echtzeit-Spannungsprofil",
    realtime_current: "Echtzeit-Flussprofil",
    realtime_active_power: "Wirkleistungsprofil in Echtzeit",
    realtime_reactive_power: "Blindleistungsprofil in Echtzeit",
    realtime_apparent_power: "Scheinbares Echtzeit-Leistungsprofil",
    realtime_energy_import_profile: "Stromverbrauch in Echtzeit",
    realtime_energy_export_profile: "Echtzeit-Stromversorgung",
    appliances_energy: "Energieverbrauch anerkannter Geräte",
    appliances_timeline: "Geräte-Timeline",
    pq_map: "PQ-Appliance-Fingerabdruckkarte",
    locations: "Standorte",
    share: "Gerät teilen",
    active_energy_last_24_hours: "Wirkenergie in den letzten 24 Stunden",
    active_energy_last_14_days: "Wirkenergie für die letzten 14 Tage",
    active_energy_last_12_months: "Wirkenergie für die letzten 12 Monate",
    reactive_energy_last_24_hours: "Reaktive Energie in den letzten 24 Stunden",
    reactive_energy_last_14_days: "Reaktive Energie in den letzten 14 Tagen",
    reactive_energy_last_12_months: "Reaktive Energie in den letzten 12 Monaten",
    hourly_total_active_energy: "Stündliche Gesamtenergie",
    daily_total_active_energy: "Tägliche Gesamtenergie",
    monthly_total_active_energy: "Monatliche Gesamtenergie",
    daily_total_reactive_energy: "Stündliche Gesamtblindenergie",
    active_power_profile_with_appliances: "Wirkleistungsprofil mit Geräten",
    energy_consumption: "Energieverbrauch",
    duration: "Dauer",
    runtime: "Lauf",
    viewFullscreen: "Vollbild anzeigen",
    printChart: "Diagramm drucken",
    downloadPNG: "PNG herunterladen",
    downloadJPEG: "Laden Sie JPEG herunter",
    downloadPDF: "PDF herunterladen",
    downloadSVG: "SVG herunterladen",
    downloadCSV: "CSV herunterladen",
    downloadXLS: "XLX herunterladen",
    viewData: "Datentabelle anzeigen",
    openInCloud: "In der Highcharts Cloud öffnen",
    resetZoom: "Zoom fortsetzen",
    loading: "Wird geladen ...",
    contextButtonTitle: "Inhaltsmenü",
    scaleChange: "Skalieren",
    weekdays: ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"],
    months: ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'],
    shortMonths: ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'],
    monitoring_availability: "Verfügbarkeit pro 24 Stunden",
    percentage_availability: "Verfügbarkeit in Prozent",
    uptime: "Betriebszeit",
    drillUpText: "◁ Zurück zu {series.name}",
    other: "Andere",
    always_on: "Immer auf",
    relay: "Relais",
    disconnector_timeline: "Zeitleiste der Relais",
    average_current: "Durchschnittlicher Strom",
    average_active_power: "Durchschnittliche Wirkleistung",
    active_energy_import: "Aktiver Energieimport",
    active_energy_export: "Aktiver Energieexport",
    frequency: "Frequenz",
    quarter_hour_active_energy: "Gesamte aktive Energie pro Viertelstunde",
    quarter_hour_maximum_active_power: "Maximale Wirkleistung in 15 Minuten",
    noData: "Keine Daten verfügbar",
    reactive_energy: "Blindleistung",
    sample: "Stichprobe",
    year_anomaly_title: "Jahresmodell des Geräts",
    month_anomaly_title: "Monatsmodell des Geräts",
    week_anomaly_title: "Wochenmodell des Gerätes",
    day_anomaly_title: "Tagesmodell des Geräts",
    duration_anomaly_title: "Dauer Modell des Geräts",
    runrun_anomaly_title: "Run-Run-Modell der Appliance"
}